<template>
  <div>
    <svg 
      v-if="tree != null"
      :width="tree.width + tree.margin.left + tree.margin.right"
      :height="tree.height + tree.margin.top + tree.margin.bottom"
    >
      <g :transform="`translate(${tree.margin.left},${tree.margin.top})`">

        <g
          class="legend"
          :transform="`translate(${-tree.margin.left},${-tree.margin.top})`"
        >
          <text
            class="text"
            alignment-baseline="center"
            y="15"
            style="font-weight: 500"
          >Legend</text>
          <foreignObject
            :width="tree.width + tree.margin.right"
            height="100"
            y="28"
          >
            <div class="countries">
              <div
                v-for="(country) in tree.countries"
                :key="country.name"
                class="country"
              >
                <div
                  class="circle"
                  :style="{backgroundColor: tree.color(country.name)}"
                />
                <span
                  class="text"
                  :style="{color: tree.color(country.name)}"
                >{{ country.name }}</span>
              </div>
            </div>
          </foreignObject>
        </g>
            
        <g class="links">
          <g
            v-for="(link, i) in tree.links"
            :key="i"
            class="link"
          >
            <path
              class="dot"
              :d="tree.diagonal({source: link.source, target: link.target})"
              stroke-width="2"
              :stroke="tree.color(link.source.data.country_origin)"
              fill="transparent"
              opacity="0.2"
            />
          </g>
        </g>

        <g class="nodes">
          <g
            v-for="(node, i) in tree.nodes"
            :key="i"
          >

            <g class="node">
              <circle
                :cy="node.x"
                :cx="node.y"
                fill="transparent"
                r="16"
              />
              <circle
                v-show="node.data.id == $route.params.song"
                :cy="node.x"
                :cx="node.y"
                :stroke="tree.color(node.data.country_origin)"
                stroke-width="1"
                fill="transparent"
                r="13"
              />
              <circle
                class="dot"
                r="7"
                :fill="tree.color(node.data.country_origin)"
                :cy="node.x"
                :cx="node.y"
              />
            </g>
          </g>
        </g>

      </g>        
    </svg>

    <div class="song-texts">
      <v-tree-item
        v-for="(node, i) in tree.nodes"
        :key="i"
        :node="node" 
      />
    </div>
  </div>
</template>

<script>

import { Tree } from "./tree.js";
import TreeItem from "./TreeItem";

export default {
	components: {
		"v-tree-item": TreeItem
	},
	data () {
		return {
			tree: null
		};
	},
	created () {
		this.tree = new Tree(this.$route.params.song);
	},
	methods: {
		onSongClick (song) {
			this.$router.push({
				name: "song",
				params: {
					song: song.id,
					section: this.$route.params.section || null
				}
			});
		}
	}
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';

.countries {
    display: flex;
    flex-wrap: nowrap;

    .country {
        display: flex;
        margin-right: 20px;
        align-items: center;
    }
    .circle {
        height: 15px;
        width: 15px;
        border-radius: 15px;
        margin-right: 6px;
    }
}

.song-texts {
    position: absolute;
    top: 93px;
    left: 30px;
}
</style>

